mutation InvoiceSigningApprovalRevoke($input: InvoiceSigningApprovalRevokeInput!) {
  invoiceSigningApprovalRevoke(
    input: $input
  ) {
    revokedApprovalEntity
  }
}